import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import Header from "../components/Header";
import AuthService from "../services/AuthService";

const AddressList = () => {

  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [address, setAddress] = useState([]);

  const searchParams = new URLSearchParams(window.location.search);
  const goto = searchParams.get('goto') || '';
  const selected_address = JSON.parse(localStorage.getItem("address"));
  const authUser = AuthService.getCurrentUser();

  const getUserAddress = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getUserAddress",
      });
      const data = response.data;

      if (data.status) {
        setAddress(data.data);
        if (data.data.length==1 && !selected_address) {
          localStorage.removeItem("branch");
          localStorage.setItem("address", JSON.stringify(address));
          // const basePath = process.env.REACT_APP_BASE_PATH;
          // window.location.href= basePath+'/address-list';
        }
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
    } finally {
      setIsLoader(false);
    }
  };


  useEffect(() => {
      if (authUser?.is_guest) {
        toast.error('Please login or create new account to use this feature.');
        navigate('/login');
      }
     getUserAddress();
  }, []);

  const saveAddress = async (address) => {
    localStorage.removeItem("branch");
    localStorage.setItem("address", JSON.stringify(address));
    // If there's a goto parameter, navigate to that page, otherwise go to home
    if (goto) {
      navigate('/' + goto);
    } else {
      navigate('/');
    }
  }

    const delAddress = async (address_id) => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "POST",
        url: "/removeAddress",
        data: {address_id}
      });
      const data = response.data;

      if (data.status) {
        if(selected_address && selected_address._id==address_id) {
          localStorage.removeItem("address");
        }
        getUserAddress();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };


  return (
    <>
    {isLoader ?(
        <PageLoader />
    ):(

      <div className="main-heading items-details-main container">
        
        <Header title={'My Address'} />



        {/* Items */}
        <div className="row px-3 mx-auto justify-content-center">
          {address && address.map((item) => (
            <div className="col-12 col-md-6">
                <div key={item.id} className={`mb-3 p-3 border rounded ${(selected_address?._id==item._id)?'bg-light':'bg-white'}`} >
                    <div class="dropdown mx-2 cursor-pointer float-end" onClick={() => delAddress(item._id)}>
                          <i className="bi bi-trash "></i>
                    </div>
                    <div class="dropdown mx-2 cursor-pointer float-end" onClick={() => navigate(`/add-address?goto=${goto}`, { state: { address:item } })}>
                          <i className="bi bi-pencil "></i>
                    </div>
                    <div className="deal-data  cursor-pointer" onClick={() => saveAddress(item)}>
                      <h6 className="text-capitalize">{item.type} {(item.is_default)?'(Primary)':''}</h6>
                      <p className="text-muted item-des">{item.address}</p>
                    </div>
                </div>
            </div>
              
          ))}
        </div>
        {address.length < 1 &&
         <h6 className="my-5 text-center"> <i className="bi bi-map-marker"></i>
          No Address found!</h6>
        }
        <div className="row">
          <div className="col-12 text-center">
            <Link to={`/add-address?goto=${goto}`} className="btn btn-base mx-3">Add New Address</Link>

          </div>
        </div>
        

      </div>

    )}
      
    </>
  );
};

export default AddressList;
